/**
 * Part of https://github.com/uselesscode/ucsv/blob/f2309d4d8bcae6d3ce740ff073d1d85c5f15367f/source/core.js
 */
const iconv = require('iconv-lite')

export class CsvWriter {

  #rxIsInt = /^\d+$/
  #rxIsFloat = /^\d*\.\d+$|^\d+\.\d*$/
  // If a string has leading or trailing space,
  // contains a comma double quote or a newline
  // it needs to be quoted in CSV output
  #rxNeedsQuoting = /^\s|\s$|,|"|\n/

  delimiter = ';'

  #isNumber(o) {
    return Object.prototype.toString.apply(o) === '[object Number]'
  }

  #isString(o) {
    return Object.prototype.toString.apply(o) === '[object String]'
  }

  #prepField (field) {
    if (this.#isString(field)) {
      // Escape any " with double " ("")
      field = field.replace(/"/g, '""')

      // If the field starts or ends with whitespace, contains " or , or a newline or
      // is a string representing a number, quote it.
      if (this.#rxNeedsQuoting.test(field) || this.#rxIsInt.test(field) || this.#rxIsFloat.test(field)) {
        field = '"' + field + '"'
        // quote empty strings
      } else if (field === "") {
        field = '""'
      }
    } else if (this.#isNumber(field)) {
      field = field.toString(10)
    } else if (field === null || field === undefined) {
      field = ''
    } else {
      field = field.toString()
    }
    return field
  }

  /**
   * @param data
   * @param encoding
   * @returns {Promise<Uint8Array>}
   */
  async serialize (data, encoding = 'win1251') {
    let cur, out = '', row, i, j
    for (i = 0; i < data.length; i += 1) {
      row = data[i]
      for (j = 0; j < row.length; j += 1) {
        cur = row[j]

        cur = this.#prepField(cur)

        out += j < row.length - 1 ? cur + this.delimiter : cur
      }
      // End record
      out += "\n"
    }

    return iconv.encode(out, encoding)
  }
}
